<template>
	<div
		class="ks-videoeditor-track ks-videoeditor-track-video"
		:data-id="track.id"
		data-kind="video"
		:style="track_style"
		@mousedown.prevent="$emit('scrub-down', $event)"
		@click="$emit('background-click')">
		<div
			v-for="l in track.items"
			:key="l.clip.id"
			class="ks-videoeditor-clip"
			:class="{selected: l.clip.id == selected_id || l.clip.id == pair_id, fade: l.clip.transition.type == 'fade' && !l.xfade, 'fade-out': l.fade_out > 0, 'has-poster': l.clip.poster_url, 'has-wave': l.clip.type != 'image'}"
			:style="block_style(l.start, l.len, l.lane, 'video', l.clip.id)"
			@mousedown.stop.prevent="$emit('clip-down', l.clip, $event)"
			@click.stop="$emit('clip-click', l.clip, $event)">
			<div class="ks-videoeditor-handle left" draggable="false" @mousedown.stop.prevent="$emit('trim-down', l.clip, 'in', $event)"></div>
			<img v-if="l.clip.poster_url" class="ks-videoeditor-clip-poster" :src="l.clip.poster_url" draggable="false" alt="">
			<div class="ks-videoeditor-clip-text">
				<div class="ks-videoeditor-clip-title">{{ l.clip.title }}</div>
				<div class="ks-videoeditor-clip-time">{{ fmt(l.len) }}<span v-if="l.clip.transition.type == 'fade'"> &middot; fade</span><span v-if="l.fade_out > 0"> &middot; fade out</span><span v-if="l.clip.muted"> &middot; muted</span></div>
			</div>
			<wave-form
				v-if="l.clip.type != 'image'"
				:url="wave_url(l.clip)"
				:from="l.clip.in"
				:len="l.len"
				:gain="l.clip.volume / 100"
				:muted="!!(l.clip.muted || track.muted)"
				:zoom="zoom"></wave-form>
			<div class="ks-videoeditor-handle right" draggable="false" @mousedown.stop.prevent="$emit('trim-down', l.clip, 'out', $event)"></div>
		</div>
		<template v-for="l in track.items">
			<div
				v-if="l.xfade"
				:key="'x' + l.clip.id"
				class="ks-videoeditor-transition"
				:class="{selected: l.clip.id == pair_id}"
				:style="transition_style(l)"
				:title="'Fade ' + round(l.xfade.length) + ' s'"
				@mousedown.stop.prevent
				@click.stop="$emit('transition-click', l)"></div>
		</template>
	</div>
</template>

<script>
import track_mixin from './track_mixin.js'
import WaveForm from './WaveForm.vue'
import {fmt, round, wave_url} from './utils.js'

// Track of video and image clips; a fade between touching clips shows as a cross-fade marker
export default {
	mixins: [track_mixin],
	components: {WaveForm},
	props: {
		selected_id: Number,
		pair_id: Number
	},
	methods: {
		fmt,
		round,
		wave_url,
		transition_style (l) {
			return {
				left: l.start * this.zoom + "px",
				width: Math.max(l.xfade.length * this.zoom, 6) + "px",
				top: l.lane * this.lane_height + (this.lane_height - 4 - 22) / 2 + "px",
				height: "22px"
			};
		}
	}
}
</script>
